import { MetadataDefault } from '@apps/ui';

export const PREFIX_TAB_TITLE = 'ZatrzymajLicznik.pl';
export const DEFALUT_METADATA: MetadataDefault = {
  title: 'ZatrzymajLicznik.pl to sposób na tańsze zasilanie Twojego biznesu',
  description:
    'ZatrzymajLicznik.pl to wirtualny asysten klienta energii elektrycznej i gazu. U nas ceny maleją! Otrzymasz tańszą ofertę energii dzięki której zaoszczędzisz na rachunkach prądu Twojej firmy.',
  image: '/images/default_cover.jpg',
  type: 'website',
  site_name: 'ZatrzymajLicznik.pl',
  origin_domain: 'https://zatrzymajlicznik.pl'
};
